import { lazyNamed } from 'src/utils/lazyNamed';

export const PaymentMethods = {
  PaymentMethods: lazyNamed(() => import('./containers/PaymentMethods'), 'PaymentMethods'),
};
